import { useState, useEffect } from 'react';
import axios from 'axios';

const useForm = (callback, validate) => {
  const [values, setValues] = useState({
    name: "",
    email: "",
    subject: "",
    phone: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });

    // Validar el campo que cambió y actualizar los errores
    const fieldErrors = validate({ ...values, [name]: value });
    setErrors({
      ...errors,
      [name]: fieldErrors[name],
    });
  };

  const handleBlur = (e) => {
    const { name } = e.target;
    // Validar el campo que perdió el foco y actualizar los errores
    const fieldErrors = validate(values);
    setErrors({
      ...errors,
      [name]: fieldErrors[name],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Validar los campos antes de enviar la solicitud
    const fieldErrors = validate(values);
    setErrors(fieldErrors);
  
    // Verificar si hay errores
    if (Object.keys(fieldErrors).length === 0) {
      setIsSubmitting(true);
  
      try {
        const response = await axios.post(
          "http://localhost:3003/api/nodemailer/nuevocontacto",
          values
        );

        const respuesta = response.data;
        
        console.log(respuesta)

      } catch (error) {
        console.error("Error al enviar los datos:", error);
      }
    }
  };

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      callback();
    }
  }, [errors, isSubmitting, callback]);

  return { handleChange, handleBlur, handleSubmit, values, errors };
};

export default useForm;